<template>
  <div>
    <h2 v-if="alreadyLogged">
      Jesteś już zalogowany.<br />
      Trwa przekierowywanie.
    </h2>
    <a-form v-else :form="form" @submit.prevent="onSubmit" layout="vertical">
      <h2 class="text-center mb-16">Logowanie</h2>
      <a-form-item label="Adres e-mail" prop="email">
        <a-input
          type="email"
          v-model="form.email"
          auto-complete="off"
          placeholder="adres email"
        >
        </a-input>
      </a-form-item>
      <a-form-item prop="password" label="Hasło" icon="password">
        <a-input
          type="password"
          v-model="form.password"
          auto-complete="off"
          placeholder="hasło"
        >
        </a-input>
      </a-form-item>
      <a-button
        type="primary"
        html-type="submit"
        class="fluid"
        size="large"
        :loading="loading"
      >
        Zaloguj się
      </a-button>
      <router-link to="przypomnij-haslo">
        <a-button type="link" class="password-reset-link">
          Resetowanie hasła
        </a-button>
      </router-link>
    </a-form>
  </div>
</template>
<script>
import { Auth } from '@/api'

export default {
  data() {
    return {
      loading: false,
      form: {}
    }
  },
  computed: {
    alreadyLogged() {
      return window.localStorage.getItem('token')
    }
  },
  methods: {
    redirectOnSuccess() {
      this.$router.push(this.defaultRoute)
    },
    onSubmit() {
      this.loading = true
      let payload = {
        email: this.form.email,
        password: this.form.password
      }
      Auth.login(payload)
        .then(response => {
          window.localStorage.setItem(
            'token',
            'Token ' + response.data.auth_token
          )
          this.$store.dispatch('fetchUserInfo').then(() => {
            this.redirectOnSuccess()
          })
        })
        .catch(error => {
          let message = 'Wystąpił błąd podczas logowania.'

          if (error.response.data.non_field_errors) {
            message = `${message} ${error.response.data.non_field_errors}`
          }

          this.$message.error(message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  created() {
    if (this.alreadyLogged) {
      this.redirectOnSuccess()
    }
  }
}
</script>

<style lang="scss" scoped>
.password-reset-link {
  width: 100%;
  text-align: right;
  margin-top: 14px;
  margin-bottom: -8px;
}
</style>
